import { render, staticRenderFns } from "./PermissionPasswordPreview.vue?vue&type=template&id=19eff278&"
import script from "./PermissionPasswordPreview.vue?vue&type=script&lang=js&"
export * from "./PermissionPasswordPreview.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPasswordPreview.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports